import { createApi, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';

import { authenticatedBaseQuery } from '@/configuration/tokenHandling/authenticatedBaseQuery';
import { appIntl, DiagnosticsTableData } from '@/features/batteryOverview/customer/DiagnosticsTable';
import { mapData } from '@/features/batteryOverview/utils/BatteryDataUtils';
import {
    AssetAndBatteryOverview,
    ExternalBatteryOverviewListRequest,
    ExternalBatteryOverviewListResponse,
} from '@/generated/GeneratedApiTypes';

export const batteryOverviewApi = createApi({
    reducerPath: 'batteryOverviewApi',
    baseQuery: authenticatedBaseQuery,
    refetchOnMountOrArgChange: 60,
    endpoints: (builder) => ({
        getBatteryOverview: builder.query<DiagnosticsTableData, ExternalBatteryOverviewListRequest>({
            query: (body: ExternalBatteryOverviewListRequest) => ({
                url: '/battery-overview',
                method: 'POST',
                body,
            }),
            transformResponse: (
                response: ExternalBatteryOverviewListResponse,
                meta: FetchBaseQueryMeta | undefined,
                arg: ExternalBatteryOverviewListRequest,
            ): DiagnosticsTableData => {
                const intl = appIntl;

                const assetsOverview = response.assets_data.map((singleBatteryOverview: AssetAndBatteryOverview) => {
                    return mapData(singleBatteryOverview, intl);
                });

                return {
                    assets: assetsOverview,
                    hasNext: response.has_next,
                };
            },
        }),
    }),
});

export const { useGetBatteryOverviewQuery } = batteryOverviewApi;
